import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=225ff72f&scoped=true&"
import script from "./PropertyEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PropertyEdit.vue?vue&type=style&index=0&id=225ff72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ff72f",
  null
  
)

export default component.exports